import styled, { css } from 'styled-components';

export const GuideContainer = styled.div`
  ${({ theme }) => css`
    height: 100%;
    left: 0;
    pointer-events: none;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 9999;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      display: none;
    }
  `};
`;

export const GuidePopoverContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 320px;
`;

export const GuidePopoverTitle = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryMedium};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.bold};
    margin: 0;
  `}
`;

export const GuidePopoverDescription = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-size: ${theme.v2.font.sizes.xxs};
    margin: 0;
  `}
`;
